export enum Language {
  DE,
  EN
}

export function getLang(str: string) {
  switch (str) {
    case "DE":
      return Language.DE;
    case "EN":
      return Language.EN;
    default:
      return Language.DE;
  }
}
